import { render, staticRenderFns } from "./InputBank.vue?vue&type=template&id=0f28571a&scoped=true&"
import script from "./InputBank.vue?vue&type=script&lang=ts&"
export * from "./InputBank.vue?vue&type=script&lang=ts&"
import style0 from "./InputBank.vue?vue&type=style&index=0&id=0f28571a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f28571a",
  null
  
)

export default component.exports